import { z } from 'zod';
/**
 * Zone de test (admin, `FEATURE_TEST_ZONE=true` uniquement) — création manuelle
 * d'un employeur/travailleur fictif pour tester la chaîne complète en dehors de
 * la synchronisation réelle avec le système CNSS. `sourceDonnee` n'apparaît
 * volontairement dans aucun de ces schémas : elle est toujours forcée à
 * `zone_test` côté serveur (jamais une valeur fournie par le client) — voir
 * apps/api/src/modules/zone-test/zone-test.routes.ts.
 */
export const createTestEmployeurSchema = z.object({
    numeroAffiliation: z.string().min(3).max(40),
    denominationSociale: z.string().min(2).max(200),
    adressePhysique: z.string().max(2000).optional(),
    telephone: z.string().max(30).optional(),
    email: z.string().email().max(160).optional(),
    nomRepresentant: z.string().max(160).optional(),
    fonctionRepresentant: z.string().max(120).optional(),
});
export const createTestTravailleurSchema = z.object({
    employeurId: z.coerce.number().int().positive(),
    numeroImmatriculation: z.string().min(3).max(40),
    nom: z.string().min(1).max(100),
    postnom: z.string().max(100).optional(),
    prenom: z.string().max(100).optional(),
    sexe: z.enum(['M', 'F']),
    dateNaissance: z.coerce.date().optional(),
    lieuNaissance: z.string().max(160).optional(),
    nationalite: z.string().max(80).optional(),
    numeroPieceIdentite: z.string().max(60).optional(),
    etatCivil: z.string().max(20).optional(),
    emploi: z.string().max(160).optional(),
    lieuAffectation: z.string().max(160).optional(),
    dateEmbauche: z.coerce.date().optional(),
});
//# sourceMappingURL=zone-test.js.map